declare var swal: any;
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';


import { FieldData } from '../../../../../models/actor/actor';


@Component({
    selector: 'auto-gen-cvspv',
    templateUrl: './autogencvspv.component.html',
    styleUrls: ['./autogencvspv.component.scss']
})

export class AutoGenCvsPVComponent implements OnInit {
    @Input() public mode;
    @Input()
    public FormMode: string = 'Edit';
    @Input() public field: FieldData;
    ngOnInit(): void {
       
    }
}
